import React from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import FullPageIntroWithFixedNavbar from './Component/nav/nav2.js';



function App() {
  return (
    <>
      <FullPageIntroWithFixedNavbar/>
    </>
  );
}

export default App;
